/**
* @Author: zachalam
* @Date:   2017-01-19T17:13:17-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T17:13:35-08:00
*/

import React, { Component } from 'react';
import TripCreate from '../components/pages/Trips/TripCreate';
import { createNewTrip, requestTags } from '../actions/tripActions';
import { clearErrors } from '../actions/commonActions';
import { connect } from 'react-redux'
import MasterConfig from '../config/Master';
import { browserHistory } from 'react-router';
import { toast } from 'react-toastify';

class TripsCreateContainer extends Component {

  componentWillMount() {
      this.props.clearErrors();
      this.props.getAllTags();
      if(this.props.activeTrips >= MasterConfig.max_trips) {
        // redirect user if they have more than max # of trips.
        browserHistory.push("/trips");
        toast.warn(`You cannot have more than ${MasterConfig.max_trips} active trips at a time.`)
      }
  }

  render() {
    return (
      <TripCreate {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errors: state.common.errors,
    activeTrips: state.profile.trip.data.length,
    tags: state.trip.tags
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    createNewTrip: (formData) => {
      dispatch(createNewTrip(formData));
    },
    clearErrors: () => {
      dispatch(clearErrors());
    },
    getAllTags: () => {
      dispatch(requestTags())
    }
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(TripsCreateContainer);



// WEBPACK FOOTER //
// ./src/containers/TripsCreateContainer.jsx